<script>
  import SearchListItem from './SearchListItem.svelte'

  export let results;
  export let title;
  export let type;
</script>

<div class="mb-2">
  <div class="container results__header">
    {title}
  </div>
  <ul class="list-group">
    {#each results as item}
      <SearchListItem item={item} type={type} />
    {/each}
  </ul>
</div>

<style lang="scss">
  .results {
    &__header {
      font-size: 1.1rem;
      font-weight: bold;
      margin-bottom: 10px;
      padding: 0;
    }
  }
</style>